import { createElement as reactCreateElement } from "react";
import { createRoot } from "react-dom/client";
import {
  DollarSign,
  Package,
  TrendingUp,
  Handshake,
  Users,
  Cpu,
  Settings,
  Leaf,
  LayoutGrid,
  type LucideIcon
} from "lucide-react";

const ICON_MAP: Record<string, LucideIcon> = {
  category: LayoutGrid,
  finance: DollarSign,
  financial: DollarSign,
  accountable: Users,
  "human resources": Users,
  "customer success": Handshake,
  product: Package,
  market: TrendingUp,
  partnerships: Handshake,
  people: Users,
  technology: Cpu,
  operations: Settings,
  sustainability: Leaf
};

export function getIconComponent(text: string): LucideIcon | null {
  const normalized = text.trim().toLowerCase();
  return ICON_MAP[normalized] ?? null;
}

export function renderIconInCell(
  dom: HTMLElement,
  cellText: string,
  isHeader = false
): boolean {
  const normalized = cellText.trim().toLowerCase();
  const IconComponent = ICON_MAP[normalized];
  if (!IconComponent) return false;

  const wrapper = document.createElement("div");
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  wrapper.style.justifyContent = "flex-start";
  wrapper.title = cellText;

  dom.appendChild(wrapper);
  createRoot(wrapper).render(
    reactCreateElement(IconComponent, {
      size: 16,
      color: isHeader ? "#6B657A" : "#511497"
    })
  );
  return true;
}
